'use client';
import * as React from 'react';
import { forwardRef } from 'react';
import cn from 'clsx';
import styles from './tabs.module.scss.js';
import { TabsSelectProvider } from './context/select-context.js';

/**
 * Компонент Tabs
 */
const Tabs = /*#__PURE__*/forwardRef(({
  children,
  fluid,
  accent,
  size,
  type
}, ref) => /*#__PURE__*/React.createElement(TabsSelectProvider, {
  type: type
}, /*#__PURE__*/React.createElement("span", {
  role: "navigation",
  "aria-label": "\u041F\u0430\u043D\u0435\u043B\u044C \u0432\u043A\u043B\u0430\u0434\u043E\u043A"
}, /*#__PURE__*/React.createElement("ul", {
  ref: ref,
  role: "tablist",
  className: cn(styles['mtsds-tabs'], fluid && styles['mtsds-tabs--fluid'], accent && styles['mtsds-tabs--accent'], size && styles[`mtsds-tabs--size-${size}`], type && styles[`mtsds-tabs--type-${type}`])
}, children))));
Tabs.defaultProps = {
  fluid: false,
  accent: false
};

export { Tabs as MtsDsTabs, Tabs };
